import styled from 'styled-components';

export const StyledOperableStateContainer = styled.div`
  align-items: center;
  display: inline-flex;
`;
